import { StatusBar, StatusBarStyle } from 'expo-status-bar'
import { useCallback, useState } from 'react'
import {
  Image,
  Platform,
  SafeAreaView,
  StatusBar as RNStatusBar,
  StyleSheet,
  TouchableOpacity,
  View,
  ScrollView
} from 'react-native'

import { Palette } from '@ppwr/poker'

import { DS } from '../../design-system'
import { useStore } from '../../models'
import { events } from '../../models/analytics/analytics-events'
import { LiveEventModelType } from '../../models/monday/monday.store'
import { EventListSelection } from './EventListSelection'
import { EventType } from './name-screen.interface'
import { useLocalSearchParams, useRouter, useFocusEffect } from 'expo-router'
import { defaultBreakPoints, isWeb } from '@/components/WebWrapper'

export const WhichEventScreen = () => {
  const router = useRouter()

  const [selectedEvent, setSelectedEvent] = useState<LiveEventModelType | null>(null)

  const { eventType } = useLocalSearchParams()

  const store = useStore()
  const {
    monday: { fetchMondayEvents, getInPersonEvents, getVirtualEvents, setSelectedEventData }
  } = useStore()

  const eventsToShow = eventType === EventType.InPerson ? getInPersonEvents() : getVirtualEvents()

  const trackEvent = (eventName: string) => {
    store.analytics.setEvent(events.onboarding.which_event_form_completed, {
      eventName: eventName,
      segmentUserId: store.analytics.getSegmentUserID(),
      segmentIdentity: store.analytics.getUserIdentify()
    })
  }

  const onNext = () => {
    if (!selectedEvent) return
    trackEvent(selectedEvent?.eventName ?? '')
    setSelectedEventData({ eventName: selectedEvent?.eventName, date: selectedEvent?.date })
    console.log('#####: ', selectedEvent)
    router.navigate('/onboarding/change-name')
  }

  const onBack = () => {
    if (router.canGoBack()) {
      return router.back()
    }
    router.replace('/onboarding/where-are-you')
  }

  useFocusEffect(
    useCallback(() => {
      fetchMondayEvents()
    }, [fetchMondayEvents])
  )

  return (
    <SafeAreaView style={styles.safeAreaView}>
      <StatusBar animated={true} style={'dark' as StatusBarStyle} hidden={false} />
      <View style={styles.webContainer} id="web-container">
        <DS.Frame style={styles.container}>
          <TouchableOpacity onPress={onBack} style={styles.backButton}>
            <Image
              style={{ height: 24, width: 24 }}
              source={require('../../../assets/userInfo/back.png')}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <ScrollView contentContainerStyle={styles.screenContainer}>
            <DS.Text variant="Heading 2/Regular">Which event are you at?</DS.Text>
            <DS.Frame style={styles.listContainer}>
              {eventsToShow.length > 0 ? (
                <EventListSelection
                  list={eventsToShow}
                  onPress={(item) => {
                    setSelectedEvent(item)
                  }}
                />
              ) : (
                <DS.Text variant="Body Large/Regular">No events found</DS.Text>
              )}
            </DS.Frame>
            <DS.Button
              disabled={!selectedEvent}
              onPress={onNext}
              variant="Large/Primary"
              type="On Light"
              style={{ alignSelf: 'flex-end', marginBottom: 16 }}
            >
              Next
            </DS.Button>
          </ScrollView>
        </DS.Frame>
      </View>
    </SafeAreaView>
  )
}

export const styles = StyleSheet.create({
  webContainer: {
    flexGrow: 1,
    width: '100%',
    maxWidth: isWeb ? defaultBreakPoints.sm : undefined,
    marginHorizontal: isWeb ? 'auto' : undefined
  },
  safeAreaView: {
    backgroundColor: Palette['Brand/Cream'],
    paddingTop: Platform.OS === 'android' ? RNStatusBar.currentHeight : 0,
    paddingBottom: Platform.OS === 'android' ? 16 : 0,
    flexGrow: 1
  },
  backButton: {
    paddingTop: 16 //Platform.OS === 'android' ? 20 : 0
  },
  container: {
    paddingHorizontal: 24,
    gap: 20,
    flexGrow: 1
  },
  screenContainer: { flex: 1 },
  listContainer: {
    flex: 1,
    marginVertical: 8
  }
})
